import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import settingDrawer from './en-US/settingDrawer';
export default _objectSpread({}, settingDrawer);